import BaseApi from '@/api/base-api'

class MerchantSupportApi extends BaseApi {
  submitCallbackRequest = (data) => {
    // Map inquiry type to integer - handle both old format ("1"/"2") and new format ("online"/"in_store")
    const inquiryTypeMap = {
      '1': 1,
      online: 1,
      '2': 2,
      in_store: 2,
    }
    const inquiryType = inquiryTypeMap[data.inquiryAbout] || 2

    // Build callback reason - default to "other" so backend can rely on reason_text
    const callbackReason = data.purposeOfCall || 'other'

    // Build reason text - only for "other" case, allow caller to pass extra context
    let reasonText = ''
    if (callbackReason === 'other') {
      if (data.purposeOfCallOther) {
        reasonText = data.purposeOfCallOther.trim()
      }

      if (data.context && data.context.trim()) {
        reasonText = reasonText
          ? `${reasonText}. ${data.context.trim()}`
          : data.context.trim()
      }
    }

    const formatIso = (date) => {
      const normalizedDate = new Date(date)
      normalizedDate.setUTCSeconds(0, 0)
      return normalizedDate.toISOString()
    }

    const isAsap = data.callbackTime === 'asap'
    // Calculate scheduled time from callback time slot
    let scheduledTimeStart = null
    let scheduledTimeEnd = null

    if (data.callbackTime && !isAsap) {
      const [startTime, endTime] = data.callbackTime.split('-')
      const [startHour, startMinute] = startTime.split(':').map(Number)
      const [endHour, endMinute] = endTime.split(':').map(Number)

      let scheduledDate
      if (data.callbackDay && /^\d{4}-\d{2}-\d{2}$/.test(data.callbackDay)) {
        const [y, m, d] = data.callbackDay.split('-').map(Number)
        scheduledDate = new Date(y, m - 1, d, startHour, startMinute, 0, 0)
      } else {
        scheduledDate = new Date()
        scheduledDate.setHours(startHour, startMinute, 0, 0)
        scheduledDate.setSeconds(0, 0)
      }

      // toISOString() automatically converts the local time to UTC
      scheduledTimeStart = formatIso(scheduledDate)

      const endDate = new Date(scheduledDate)
      endDate.setHours(endHour, endMinute, 0, 0)
      endDate.setSeconds(0, 0)
      scheduledTimeEnd = formatIso(endDate)
    }

    const requestData = {
      country_code: data.countryCode,
      phone_number: data.phoneNumber?.replace(/^0/, ''),
      inquiry_type: inquiryType,
      callback_reason: callbackReason,
      reason_text: reasonText.trim(),
      language: data.callbackLanguage || 'en',
    }

    if (!isAsap && scheduledTimeStart && scheduledTimeEnd) {
      requestData.scheduled_time_start = scheduledTimeStart
      requestData.scheduled_time_end = scheduledTimeEnd
    }

    return this.request(
      {
        method: 'POST',
        path: this.uri + `/${data.merchantId}/submit-callback-request`,
        data: requestData,
      },
      {
        options: {
          hideMessage: true,
        },
      }
    )
  }
}

export default new MerchantSupportApi('/v2/merchant/support')
